import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSMenuActionProps } from "namirasoft-site-react";
import { MessageRouterProps } from "./MessageRouterProps";

export class MessageMenus
{
	static MarkAllAsSeen(props: NSARouterMakerResult & MessageRouterProps): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "All",
			isActive: () =>
			{
				return true;
			},
			onClick: {
				action: async (onFinished) =>
				{
					try
					{
						await props.servers.message.message.SeenAll();
						window.location.reload();
					}
					catch
					{
						// The server already reported the error through the notifier.
					}
					finally
					{
						onFinished();
					}
				},
				showLoading: true
			}
		}
	}
	static MarkAsSeen(props: NSARouterMakerResult & MessageRouterProps, getIDs: () => string[]): NSMenuActionProps
	{
		return {
			id: "2",
			menu_item: "Selected",
			isActive: () =>
			{
				return getIDs().length > 0;
			},
			onClick: {
				action: async (onFinished) =>
				{
					try
					{
						let ids = getIDs();
						for (let i = 0; i < ids.length; i++)
						{
							const id = ids[i];
							await props.servers.message.message.Seen(id);
						}
						window.location.reload();
					}
					catch
					{
						// The server already reported the error through the notifier.
					}
					finally
					{
						onFinished();
					}
				},
				showLoading: true
			}
		}
	}
}